import React, { ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';
import ProfileCard from './basic/ProfileCard';
import { Link } from 'react-router-dom';
import { Mode } from '../profile.type';
import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faKey } from '@fortawesome/free-solid-svg-icons';
import { routeMapping } from '../config';
import { Props } from './profileView.type';
import InstitutionProfileInfoCard from './profileInfo/InstitutionProfileInfoCard';
import CandidateProfileInfoCard from './profileInfo/CandidateProfileInfoCard';
import CandidateSkillCard from './profileInfo/CandidateSkillCard';
import RecruiterProfileInfoCard from './profileInfo/RecruiterProfileInfoCard';
import CanAccess from 'components/modules/auth/Access/CanAccess';

const defaultBreadcrumbItems: Record<Mode, PageBreadcrumbItem[]> = {
  institution: [
    {
      label: 'Profile',
      url: '/hub/profile',
      active: true
    }
  ],
  candidate: [
    {
      label: 'Profile',
      url: '/home/profile',
      active: true
    }
  ],
  recruiter: [
    {
      label: 'Profile',
      url: '/panel/profile',
      active: true
    }
  ]
};

function ProfileView({ mode }: Props) {
  const infoMapping: Record<Mode, ReactNode> = {
    institution: <InstitutionProfileInfoCard />,
    candidate: <CandidateProfileInfoCard />,
    recruiter: <RecruiterProfileInfoCard />
  };
  return (
    <>
      <PageBreadcrumb items={defaultBreadcrumbItems[mode]} />
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">Profile</h2>
        </Col>
        <CanAccess action="canUpdate" entity="profile">
          <Col xs="auto" className="d-flex flex-wrap gap-2 gap-sm-3">
            <Button
              variant="phoenix-secondary"
              as={Link}
              to={routeMapping[mode].edit}
              startIcon={<FontAwesomeIcon className="me-2" icon={faEdit} />}
            >
              Edit
            </Button>
            <Button
              variant="phoenix-secondary"
              as={Link}
              startIcon={<FontAwesomeIcon className="me-2" icon={faKey} />}
              to={routeMapping[mode].reset}
            >
              Reset password
            </Button>
          </Col>
        </CanAccess>
      </Row>
      <Row className="g-3 mb-6">
        <Col xs={12} lg={5}>
          <ProfileCard />
        </Col>
        <Col xs={12} lg={7}>
          {infoMapping[mode]}
        </Col>
        {mode === 'candidate' && (
          <Col xs={12}>
            <CandidateSkillCard />
          </Col>
        )}
      </Row>
    </>
  );
}

export default ProfileView;
